import { render, staticRenderFns } from "./RiskInfo.vue?vue&type=template&id=339011d2&scoped=true&"
var script = {}
import style0 from "./RiskInfo.vue?vue&type=style&index=0&id=339011d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339011d2",
  null
  
)

export default component.exports